const prodEnv = require('./prod.env')
const merge = require('webpack-merge')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  API_ROOT: 'https://mangalgril.ru',
  FRONT_URL: 'http://localhost:8082'
})



// WEBPACK FOOTER //
// ./config/dev.env.js